import { ChipList } from "@/components/ChipList";
import { TextArrayField } from "@/fields/TextArrayField";

import { useCountries } from "../api";

type Props = {
  source: string;
  label?: string;
  max?: number;
};

const MAX_COUNTRIES = 10;

export const CountriesTextArrayFields = ({
  max = MAX_COUNTRIES,
  ...props
}: Props) => {
  const { data: { countriesObject = {} } = {} } = useCountries();

  return (
    <TextArrayField {...props} valuesLabels={countriesObject} sortable={false}>
      <ChipList max={max} />
    </TextArrayField>
  );
};
